module.exports = __webpack_public_path__ + "img/safety-woman2.4dc03434.png";